if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('appstle_sub_widget')) {
             const isProductPage = BSS_B2B.page.isProductPage()

              if (!isProductPage) {
                return;
              }

              const oneTimePriceWrapper = document.querySelector(".appstle_one_time_price_wrapper");
              const subscriptionWrapper = document.querySelector(".appstle_subscription_amount_wrapper");

              const product = document.querySelector(`form input[name="product-id"]`)
              const pID = product.getAttribute("value")
              if(oneTimePriceWrapper) {
                  oneTimePriceWrapper.setAttribute("bss-b2b-product-id", pID);           
                  oneTimePriceWrapper.setAttribute("bss-b2b-product-price", true);
              }

              // price in Appstle block
              setTimeout(() => {
                if (!oneTimePriceWrapper || !subscriptionWrapper) return;

                const priceSpans = oneTimePriceWrapper.querySelectorAll("span");

                let minPrice = null;

                priceSpans.forEach(span => {
                  let priceText = span.textContent.replace(/[^\d,.-]/g, "");
                  priceText = priceText.replace(",", ".");
                  let price = parseFloat(priceText);

                  if (!isNaN(price)) {
                    if (minPrice === null || price < minPrice) {
                      minPrice = price;
                    }
                  }
                });

                if (minPrice !== null) {
                  const salePrice = (minPrice * 0.9).toFixed(2).replace(".", ",");

                  if (priceSpans.length === 1) {
                    // one price
                    const color = window.getComputedStyle(priceSpans[0]).color;
                    subscriptionWrapper.innerHTML = `
                      <span style="color: ${color};">
                        €${salePrice}
                      </span>
                    `;
                  } else {
                    // two price
                    const color = window.getComputedStyle(priceSpans[0]).color;
                    const lastColor = window.getComputedStyle(priceSpans[priceSpans.length - 1]).color;
                    subscriptionWrapper.innerHTML = `
                      <span style="text-decoration: line-through; color: ${color}; margin-right: 5px;">
                        €${minPrice.toFixed(2).replace(".", ",")}
                      </span>
                      <span style="color: ${lastColor};">
                        €${salePrice}
                      </span>
                    `;
                  }
                }
              }, 500);
          BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

  if (window?.BSS_SUB) {
    window.addEventListener('bss_sub:loaded_customize', () => {
const dictionaries = {
    page: {
        contracts: {
            pageTitle: 'Ihre Abonnements',
            view: {
                list: 'Liste',
                grid: 'Gitter',
            },
            search: {
                placeholder: 'Vertragsnummer: #1234567890',
            },
            empty: {
                title: 'Noch keine Verträge',
                content: 'Keine Verträge gefunden. Bitte versuchen Sie eine andere Suche.',
            },
            productCard: {
                title: '{{contractId}} - {{quantity}} artikel',
                nexBilling: 'Nächstes Rechnungsdatum:',
            },
        },
        contract: {
            header: {
                title: 'Abonnement {{contractId}}',
                cycle: 'Aktueller Abrechnungszeitraum',
                createAt: 'Erstellt am {{createAt}}',
                order: {
                    next: 'Nächste Bestellung',
                    button: 'Jetzt bestellen',
                    buttonLoading: 'Bestellung...',
                    buttonProgress: 'Bestellung in Bearbeitung...',
                    buttonChecking: 'Status überprüfen...',
                },
            },
            general: {
                title: 'Allgemeines',
                order: {
                    title: 'Details zur nächsten Bestellung',
                    product: 'Produkt',
                    total: 'Gesamt',
                    subtotal: 'Zwischensumme',
                    quantity: 'Menge',
                    sku: 'SKU',
                    initPrice: 'Anfangspreis: ',
                },
                frequency: {
                    title: 'Bestellhäufigkeit',
                    billing: 'Abrechnungshäufigkeit',
                    delivery: 'Lieferhäufigkeit',
                    max: 'Maximale Zyklen',
                    min: 'Minimale Zyklen',
                },
                shipping: {
                    title: 'Lieferadresse',
                    type: 'Lieferart',
                    empty: {
                        content: 'Keine Lieferadresse angegeben.',
                    },
                },
                payment: {
                    title: 'Zahlungsweise',
                    expires: 'Läuft ab {{time}}',
                },
                discount: {
                    title: 'Rabatte',
                    apply: 'Bewerben',
                },
                related: {
                    title: 'Das könnte Ihnen auch gefallen',
                },
            },
            upcoming: {
                title: 'Kommende Bestellung',
                moreDetail: 'Weitere Details',
                cycle: {
                    order: 'Bestellung:',
                    orderSummary: '{{qty}} Artikel - {{price}}',
                    plan: 'Plan: {{plan}}',
                    sku: 'SKU: {{sku}}',
                },
                empty: {
                    title: 'Keine anstehenden Bestellungen',
                    content: 'Ihr Vertrag ist nicht aktiv, bitte überprüfen Sie Ihren Vertragsstatus!',
                },
            },
            past: {
                title: 'Frühere Bestellungen',
                firstOrder: 'Erste Bestellung',
            },
        },
        modal: {
            addProduct: {
                title: 'Produkt hinzufügen',
                chooseDescription: 'Fügen Sie Ihrer Bestellung ein Produkt hinzu.',
                addDescription: 'Ändern Sie die Menge des Produkts',
                search: {
                    placeholder: 'Produktname',
                },
                quantity: 'Menge',
            },
            frequency: {
                title: 'Bestellhäufigkeit',
                description: 'Ändern Sie die Bestellhäufigkeit für diesen Vertrag.',
                select: {
                    title: 'Aus bestehendem Verkaufsplan auswählen',
                    placeholder: 'Wählen Sie einen Verkaufsplan aus',
                },
                custom: 'Benutzerdefinierte Frequenz',
            },
            shipping: {
                change: {
                    title: 'Adressdaten ändern.',
                    description: 'Wählen Sie eine neue Adresse aus.',
                    current: 'Aktuelle Adresse',
                    another: 'Wählen Sie eine andere Adresse',
                    choosePickup: 'Abholort auswählen',
                },
                edit: {
                    title: 'Adresse bearbeiten',
                    description: 'Bearbeiten Sie die ausgewählte Adresse.',
                },
            },
            payment: {
                title: 'Zahlungsmethode bearbeiten',
                description: 'Wählen Sie eine Zahlungsmethode für diesen Vertrag aus.',
                methods: 'Zahlungsmethoden:',
                sendLink: 'Link zum Aktualisieren der Karte senden',
                empty: {
                    content: 'Keine Zahlungsmethoden gefunden.',
                },
            },
            skipOrder: {
                title: 'Bestellung überspringen',
                content: 'Möchten Sie die Bestellung wirklich überspringen?',
            },
            resumeOrder: {
                title: 'Auftrag fortsetzen',
                content: 'Möchten Sie die Bestellung wirklich fortsetzen?',
            },
            orderNow: {
                title: 'Jetzt bestellen',
                content: 'Sind Sie bereit, Ihre Bestellung aufzugeben?',
                note1: 'Bitte beachten Sie, dass die Bearbeitung Ihrer Bestellung nach der Bestätigung bis zu 5 Minuten dauern kann.',
                note2: 'Sie können die Seite aktualisieren, um den aktuellen Status anzuzeigen.',
            },
        },
    },
    order: {
        product: 'Produkt',
        total: 'Gesamt',
        subtotal: 'Zwischensumme',
        quantity: 'Menge',
        sku: 'SKU',
    },
    form: {
        address: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            phoneNum: 'Telefonnummer',
            company: 'Unternehmen',
            address1: 'Adresse 1',
            address2: 'Adresse 2',
            city: 'Stadt',
            zip: 'Reißverschluss',
            country: 'Land',
            province: 'Provinz',
        },
    },
    action: {
        detail: 'Details anzeigen',
        pagination: {
            next: 'Weiter',
            previous: 'Zurück',
        },
        cancel: 'Abbrechen',
        addToCard: 'In den Warenkorb',
        addToOrder: 'Zur Bestellung hinzufügen',
        addProduct: 'Hinzufügen',
        edit: 'Bearbeiten',
        save: 'Speichern',
        select: 'Auswählen',
        active: 'Aktiv',
        placeOrder: 'Bestellung aufgeben',
        recharge: 'Aufladen',
        skip: 'Überspringen',
        resume: 'Lebenslauf',
        reschedule: 'Neu terminieren',
        search: {
            button: 'Suche',
            buttonLoading: 'Suchen',
        },
    },
    filter: {
        title: 'Filter',
        filterAdd: 'Filter hinzufügen',
        filterType: 'Filtertyp',
        placeholder: 'Filtertyp auswählen',
        apply: 'Filter anwenden',
    },
    loading: {
        title: 'Laden...',
    },
    status: {
        inProgress: 'In Bearbeitung',
    },
  };
  if (window?.Shopify?.locale === 'de') {
      window?.BSS_SUB?.custom?.addFilter('custom:translation-dictionaries', () => dictionaries);
  }
  });
}